import "core-js/modules/es6.regexp.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { shouldUseSentry } from '../../sentry';
export default {
  name: 'ErrorFallbackErrorPage',
  props: {
    error: {
      type: Error,
      required: true,
      "default": ''
    },
    info: {
      type: String,
      required: true,
      "default": ''
    },
    element: {
      type: String,
      required: true,
      "default": ''
    }
  },
  data: function data() {
    return {
      showErrorDetails: false,
      shouldUseSentry: shouldUseSentry()
    };
  },
  computed: {
    color: function color() {
      return this.$store.state.app.color || '#00a9e1';
    },
    feedbackEmailAddress: function feedbackEmailAddress() {
      return this.$store.state.app.feedbackEmail;
    }
  },
  methods: {
    reload: function reload() {
      window.location.reload();
    },
    showDetails: function showDetails() {
      this.showErrorDetails = !this.showErrorDetails;
    },
    getMessageText: function getMessageText() {
      return this.$i18n_t('Common.errorboundary.messageNoSentry', {
        mailtoLink: this.getMailToLink(),
        mailtoLinkText: this.feedbackEmailAddress
      });
    },
    getMailToLink: function getMailToLink() {
      try {
        var subject = "Error report for ".concat(window.location.href);
        // remove host from location
        var errorLocation = window.location.href.replace(window.location.origin, '');
        var errorStack = this.error.stack;
        var errorInfo = "".concat(this.info, " in ").concat(this.element);
        var body = encodeURIComponent("\n\n\n========\nError details for \"".concat(this.error.message, "\"\n").concat(errorLocation, " - ").concat(errorInfo, "\n\n").concat(errorStack, "\n========"));
        return "mailto:".concat(this.feedbackEmailAddress, "?subject=").concat(subject, "&body=").concat(body);
      } catch (error) {
        var _subject = "Error report for ".concat(window.location.href);
        return "mailto:".concat(this.feedbackEmailAddress, "?subject=").concat(_subject);
      }
    }
  }
};